<template>
  <section class="about-app-store">
    <div class="about-app-store__contents">
      <div class="about-app-store__content">
        <GifteeAppIcon class="about-app-store__giftee-app-icon" />
        <p class="about-app-store__text">
          ギフトのある生活を、もっと身近に。
        </p>
        <p class="about-app-store__description">
          アプリ版「giftee」をご利用いただく方は<br />こちらからダウンロード
        </p>
        <div class="about-app-store__app-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=co.giftee.app&utm_source=about"
            class="about-app-store__google-play"
          >
            <img
              src="../../../../../../images/abouts/buttons/google-play-badge.png"
              alt="google-play"
            />
          </a>
          <a
            href="https://itunes.apple.com/us/app/giftee/id508754185?l=ja&ls=1&pt=999334&ct=about&mt=8
"
            class="about-app-store__app-store"
          >
            <img :src="appStoreIcon" alt="app_store" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppStoreIcon from '../../../../../../images/abouts/buttons/Download_on_the_App_Store_Badge_JP_RGB_blk_100317.svg'
import GifteeAppIcon from '../../../atoms/icons/GifteeAppIcon'
export default {
  components: { GifteeAppIcon },
  data() {
    return {
      appStoreIcon: ''
    }
  },
  mounted() {
    this.appStoreIcon = AppStoreIcon
  }
}
</script>

<style lang="scss" scoped>
.about-app-store {
  background-color: $gray-3;
  padding: 40px 80px;

  @media all and (max-width: $pc-width  - 1) {
    padding: 40px 24px;
  }

  &__contents {
    margin: auto;
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    max-width: 1040px;
    background-color: $white;
    background-position: right center;
    background-image: url('../../../../../../images/abouts/bg_image/app_image.png');
    background-repeat: no-repeat;
    background-size: 70%;
    border-radius: 16px;

    @media all and (max-width: $pc-width  - 1) {
      max-width: 408px;
      background: $white;
    }
  }

  &__content {
    padding: 48px 0;
    max-width: 488px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media all and (max-width: $pc-width  - 1) {
      padding: 24px 0;
    }
  }

  &__giftee-app-icon {
    width: 80px;
    height: 80px;
  }

  &__text {
    margin-top: 24px;
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1.6;
    letter-spacing: 0.06em;
    color: $black;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.6rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 1.4rem;
    }
  }

  &__description {
    margin-top: 24px;
    font-size: 1.4rem;
    line-height: 2;
    letter-spacing: 0.06em;
    color: $black;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.2rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 1rem;
    }
  }

  &__app-buttons {
    margin-top: 24px;
    display: flex;
    align-items: center;
  }

  &__google-play {
    margin-right: 24px;
    height: 60px;
    width: 100%;

    @media all and (max-width: $pc-width  - 1) {
      margin-right: 0;
    }

    @media all and (max-width: $sp-iphone5-width) {
      height: 52px;
    }

    img {
      @extend %hover-common;
      height: 100%;
    }
  }

  &__app-store {
    padding-right: 7px;
    display: flex;
    align-items: center;
    height: 42px;
    width: 100%;

    @media all and (max-width: $sp-iphone5-width) {
      height: 38px;
    }

    img {
      @extend %hover-common;
      height: 100%;
    }
  }
}
</style>
